module.exports = __webpack_public_path__ + "img/case_11.e4bbf423.png";